<template>
	<div class="text-left pb-5">

		<!--		<div class="content">-->
		<!--			<div class="search-box search-color bg-dark1-dark rounded-xl bottom-0">-->
		<!--				<i class="fa fa-search" @click="searchDocument()"></i>-->
		<!--				<input type="text" class="border-0" placeholder="Zoek hier...  " data-search="" @keyup.enter="searchDocument()" v-model="filter.search">-->
		<!--			</div>-->
		<!--		</div>-->

		<router-link :to="'/spots/'+ spot.id" class="card card-style mb-3" v-for="(spot, index) in list" :key="index">

			<div class="content">
				<h3>{{ spot.name }}</h3>
				<div>
					<div class="row mb-0">
						<div class="col-4"><p class="font-14 mb-0 font-800 color-theme text-left">Tijd</p></div>
						<div class="col-4"><p class="font-14 mb-0 font-800 color-theme">Wind</p></div>
						<div class="col-4"><p class="font-14 mb-0 font-800 color-theme text-right">Weer</p></div>
						<div class="divider w-100 mb-2 mt-2"></div>
					</div>
				</div>

				<div class="row mb-0"  v-if="spot.wind && spot.wind.hourly && spot.wind.hourly.winddirection_10m" :style="getBackgroundColor(spot)" style="border-bottom: 1px solid #dedede;padding-top: 4px; padding-bottom: 0px; height:60px; position: relative">
					<div class="col-3">
						<div class="float-left p-2 font-15 mb-0 font-500 color-white text-left">
							{{nextHour}}h
<!--							{{ time | moment('H') }}h-->
						</div>
						<div class="float-right mt-2 icon-direction-solid-grey" style="height: 21px; width: 15px;" :style="$root.getDirection(spot.wind.hourly.winddirection_10m[nextHour])"></div>
						<div class="float-right direction">
							<small>{{ spot.wind.hourly.winddirection_10m[nextHour] }}°</small>
						</div>
					</div>
					<div class="col-5"><p class="font-13 p-2 mb-0 font-800 color-theme" style="line-height: 13px;">
						{{ spot.wind.hourly.windspeed_10m[nextHour] }} kts
						<small>Windstoten: {{ spot.wind.hourly.windgusts_10m[nextHour] }}kts</small>
					</p>
					</div>
					<div class="col-4">
						<div class="float-left weather-icon" :class="$root.getCloudForecast(spot.wind.hourly.cloudcover[nextHour])"></div>
						<div>
							<div v-if="spot.wind.hourly.precipitation[11] > 0" class="rainicons" :class="$root.getRainForecast(spot.wind.hourly.precipitation[nextHour])"></div>
							<small class="rain_amount" v-if="spot.wind.hourly.precipitation[nextHour] > 0"> {{ spot.wind.hourly.precipitation[11] }} mm</small>
						</div>
						<div class="float-right font-500 font-15">{{ spot.wind.hourly.temperature_2m[nextHour] }}°C</div>
					</div>
					<div class="windborder" :style="$root.getWindspeedGusts(spot.wind.hourly.windspeed_10m[nextHour])"></div>
					<div class="windborder" :style="$root.getWindspeedGusts(spot.wind.hourly.windgusts_10m[nextHour])"></div>

					<!--						<div style="height:3px;width:40%;background-color:orange;">-->

					<!--						</div>-->
				</div>
			</div>
		</router-link>



		<infinite-loading @infinite="getSpots">
			<div slot="no-more">.</div>
		</infinite-loading>


		<Menu>
			<template slot="menu-items">
				<router-link class="active-nav" to="/spots"><i class="fa fa-sun"></i><span>Wind</span></router-link>
				<router-link class="" to="/spots/edit/new"><i class="fa fa-plus"></i><span>Add spot</span></router-link>
			</template>
		</Menu>

	</div>
</template>

<script>
import Menu from "@/components/Menu";
import moment from "moment";

export default {
	name: "WindSpots",
	components: {Menu},
	data: function () {
		return {
			filter: {
				page: 1,
				search: null,
			},
			spots: [],
			list: [

			],
			errormessage: null,
			page: 0,
		}
	},

	computed: {
		// a computed getter
		nextHour: function () {
			// `this` points to the vm instance
			return moment().add(1, 'hours').format('H');
		}
	},

	mounted() {

		// this.getDocuments();
	},

	methods: {

		async getWindForecast(spot) {

			try {

				let url = 'https://api.open-meteo.com/v1/forecast';
				if (this.model === 'gfs') {
					url = 'https://api.open-meteo.com/v1/gfs';
				}

				const response = await this.$http.get(url, {
					params: {
						latitude: spot.lat,
						longitude: spot.lon,
						windspeed_unit: 'kn',
						forecast_days: '14',
						timezone: 'Europe/Amsterdam',
						daily: 'sunrise,sunset',
						hourly: 'temperature_2m,windspeed_10m,winddirection_10m,windgusts_10m,cloudcover,temperature_2m,precipitation',

					},
				});

				spot.wind = response.data;
				console.log(response)


			} catch (error) {
				this.errormessage = error.response;
				console.log(error);
			}
		},


		getBackgroundColor(spot) {
			console.log('spot');
			console.log(spot);
			if (!spot.wind.hourly){
				return;
			}

			// console.log(spot.wind.hourly)
			const windspeed = spot.wind.hourly.windspeed_10m[this.nextHour];


			const data = this.$root.getColorData(windspeed);


			return `background-image: -webkit-linear-gradient(left, ${data.hex} 0%, rgba(${data.color}) ${data.percentage1});\n` +
				`    background-image: -o-linear-gradient(left, ${data.hex} 0%, rgba(${data.color}) ${data.percentage1});\n` +
				`    background-image: linear-gradient(to right, ${data.hex} 0%, rgba(${data.color}) ${data.percentage2});\n` +
				`    background-repeat: repeat-x;`;


			// #00e600 0%, rgba(0, 230, 0, 0) 44%);
			// 	background-image: -o-linear-gradient(left, #00e600 0%, rgba(0, 230, 0, 0) 44%);
			// 	background-image: linear-gradient(to right, #00e600 0%, rgba(0, 230, 0, 0) 44%);
			// 	background-repeat: repeat-x;
		},

		getSpots($state, page) {

			this.$http.get(this.$root.url + '/api/get-spots', {
				headers: this.$authHeader(),
				params: {
					page: this.filter.page,
					search: this.filter.search
				},
			}).then(({data}) => {


				if (data.data.length) {
					this.filter.page += 1;
					console.log(data.data);

					const spots = data.data;

					for (let spot of spots){
						spot.wind = this.getWindForecast(spot);
						this.list.push(spot);
					}

					// this.list.push(...data.data);
					if ($state) {
						$state.loaded();
					}

				} else {
					$state.complete();
				}

			});
		},

	}
}
</script>

<style scoped>

.icon-direction-solid-grey {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg height='16' width='10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 16L0 0l5 3.556L10 0z' fill='%234a4a4a' fill-rule='evenodd'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
}

.edit-btn {
	right: 10px;
	position: absolute;
	top: 8px;
}


.direction {
	position: absolute;
	bottom: 0px;
	right: 10px;
}

.weather-icon {
	background-repeat: no-repeat;
	width: 30px;
	height: 24px;
}

.full-cloudy {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='34' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h34v24H0z' fill='%23fff' fill-opacity='.01' opacity='.01'/%3E%3Cpath d='M4.5 13.5a6.003 6.003 0 013.222-5.32 7.503 7.503 0 0112.445-3.617A5.502 5.502 0 0126.42 9.06a5.5 5.5 0 01.749 9.436 4.765 4.765 0 01-2.596 2.641l-.084.363H14.5a4.998 4.998 0 01-4-2 6 6 0 01-6-6z' fill='%23fff' fill-rule='nonzero'/%3E%3Cpath d='M15 4c1.846 0 3.545.84 4.667 2.228a4 4 0 015.331 3.898A4.002 4.002 0 0124 18H10.5a4.5 4.5 0 01-1.452-8.76A6.001 6.001 0 0115 4z' fill='%23848484' fill-rule='nonzero'/%3E%3Cpath d='M7 13.5a3.5 3.5 0 003.5 3.5H24a3 3 0 10-.172-5.995 3 3 0 00-4.494-3.5A5 5 0 0010 10c-1.696.278-3 1.737-3 3.5z' fill='%23d4d4d4'/%3E%3Cpath d='M26 16.75A3.25 3.25 0 0122.75 20H14.5a3.5 3.5 0 01-.247-6.991 4.503 4.503 0 018.636.494A3.25 3.25 0 0126 16.75z' fill='%23848484' fill-rule='nonzero'/%3E%3Cpath d='M22 14.5a3.5 3.5 0 00-6.972-.444A2.5 2.5 0 1014.5 19h8.25a2.25 2.25 0 10-.752-4.371L22 14.5z' fill='%23ededed'/%3E%3C/g%3E%3C/svg%3E");
}

.sunny {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='34' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h34v24H0z' fill='%23fff' fill-opacity='.01' opacity='.01'/%3E%3Cpath d='M23.673 15.42l3.085 3.085-3.253 3.253-3.084-3.085c-.358.185-.733.34-1.121.466V23.5h-4.6v-4.36a7.455 7.455 0 01-1.12-.467l-3.085 3.085-3.253-3.253 3.085-3.084A7.455 7.455 0 019.86 14.3H5.5V9.7h4.36c.126-.388.282-.763.467-1.12L7.242 5.494l3.253-3.253 3.084 3.085c.358-.185.733-.34 1.121-.466V.5h4.6v4.36c.388.126.763.282 1.12.467l3.085-3.085 3.253 3.253-3.085 3.084c.185.358.34.733.466 1.121H28.5v4.6h-4.36a7.455 7.455 0 01-.467 1.12z' fill='%23fff'/%3E%3Cpath d='M23.505 4.363l1.132 1.132L18.93 11.2H27v1.6h-8.069l5.706 5.705-1.132 1.132L17.8 13.93V22h-1.6v-8.069l-5.705 5.706-1.132-1.132L15.07 12.8H7v-1.6h8.069L9.363 5.495l1.132-1.132L16.2 10.07V2h1.6v8.069z' fill='%23ffbe00' fill-rule='nonzero'/%3E%3Cpath d='M24 12c0-3.86-3.14-7-7-7s-7 3.14-7 7 3.14 7 7 7 7-3.14 7-7z' fill='%23fff'/%3E%3Cpath d='M23 12c0 3.308-2.692 6-6 6s-6-2.692-6-6 2.692-6 6-6 6 2.692 6 6z' fill='%23ffbe00' fill-rule='nonzero'/%3E%3Cpath d='M22 12c0-2.756-2.244-5-5-5s-5 2.244-5 5 2.244 5 5 5 5-2.244 5-5z' fill='gold'/%3E%3C/g%3E%3C/svg%3E");
}

.clear-night {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='34' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h34v24H0z' fill='%23fff' fill-opacity='.01' opacity='.01'/%3E%3Cpath d='M6.514 13.294l-.427-3.068 2.672 1.567a4.994 4.994 0 006.74-6.988l-1.663-2.614 3.081.317A9.514 9.514 0 116.514 13.294z' fill='%23fff' fill-rule='nonzero'/%3E%3Cpath d='M15.936 18.984a7.013 7.013 0 007.013-7.013 7.02 7.02 0 00-4.456-6.534A7.494 7.494 0 019.5 14.762a7.02 7.02 0 006.436 4.222z' fill='%23b7e2ee'/%3E%3Cpath d='M15.936 18.984a7.013 7.013 0 007.013-7.013 7.02 7.02 0 00-4.456-6.534A7.494 7.494 0 019.5 14.762a7.02 7.02 0 006.436 4.222zm-4.656-5.009A6.494 6.494 0 0016.764 4 8.014 8.014 0 118 13.087a6.464 6.464 0 003.28.888z' fill='%236ebace' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E");
}

.mostly-sunny {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='34' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h34v24H0z' fill='%23fff' fill-opacity='.01' opacity='.01'/%3E%3Cpath d='M17.171 21.5H12.7v-4.42a6.46 6.46 0 01-.372-.155l-3.126 3.126-3.253-3.253L7.247 15.5H5.5a4 4 0 01-.347-7.985 4.493 4.493 0 012.149-.96L5.949 5.201l3.253-3.253 3.126 3.126a6.46 6.46 0 01.372-.155V.5h4.6v4.42c.126.048.25.1.372.155l3.126-3.126 3.253 3.253-3.126 3.126c.055.122.107.246.155.372h4.42v3.217a5.005 5.005 0 012.023 1.613A4.5 4.5 0 0127 22.5h-7a4.481 4.481 0 01-2.829-1z' fill='%23fff'/%3E%3Cpath d='M16.931 11.8H24v-1.6h-7.069l4.999-4.998-1.132-1.132L15.8 9.07V2h-1.6v7.069L9.202 4.07 8.07 5.202 13.07 10.2v1.6L8.07 16.798l1.132 1.132L14.2 12.93V20h1.6v-7.069z' fill='%23ffbe00' fill-rule='nonzero'/%3E%3Cpath d='M15 5c-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6-2.692-6-6-6z' fill='%23fff'/%3E%3Cpath d='M20 11c0 2.757-2.243 5-5 5s-5-2.243-5-5 2.243-5 5-5 5 2.243 5 5z' fill='%23ffbe00' fill-rule='nonzero'/%3E%3Cpath d='M19 11c0-2.205-1.795-4-4-4s-4 1.795-4 4 1.795 4 4 4 4-1.795 4-4z' fill='gold'/%3E%3Cg fill-rule='nonzero'%3E%3Cpath d='M8 7a4 4 0 110 8H5.5a3.5 3.5 0 01-.15-6.997A3.995 3.995 0 018 7zM23.5 12c1.557 0 2.938.793 3.747 2.008A4 4 0 0127 22h-7a4 4 0 01-.247-7.992A4.499 4.499 0 0123.5 12z' fill='%23fff'/%3E%3Cpath d='M8 8a3 3 0 110 6H5.5a2.5 2.5 0 11.252-4.987A2.998 2.998 0 018 8z' fill='%23a5a5a5'/%3E%3C/g%3E%3Cpath d='M8 13a2 2 0 10-1.817-2.836A1.5 1.5 0 105.5 13z' fill='%23fff'/%3E%3Cpath d='M23.5 13c1.396 0 2.612.82 3.172 2.018A3 3 0 1127 21h-7a3 3 0 11.328-5.982A3.502 3.502 0 0123.5 13z' fill='%23a5a5a5' fill-rule='nonzero'/%3E%3Cpath d='M20 20h7a2 2 0 10-1.01-3.727 2.5 2.5 0 00-4.98 0A2 2 0 1020 20z' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E");
}

.half-cloudy {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='34' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h34v24H0z' fill='%23fff' fill-opacity='.01' opacity='.01'/%3E%3Cpath d='M22.086 22.5H12a5.5 5.5 0 01-5.464-4.871C4.244 17.189 2.5 15.214 2.5 12.82c0-2.204 1.484-4.071 3.535-4.686C7.02 5.958 9.25 4.5 11.76 4.5c1.1 0 2.142.28 3.048.772l2.337-2.274L19.7 5.445V2h4.6l.002 3.445 2.325-2.447 3.252 3.253L27.553 8.7H31v4.6h-3.447l2.45 2.418-2.97 2.969-.567-.508v.376a4.5 4.5 0 01-4.38 3.944z' fill='%23fff' fill-rule='nonzero'/%3E%3Cpath d='M22.8 3.5h-1.6v5.569L17.262 5.13l-1.131 1.131 3.938 3.938H14.5v1.6h5.569l-3.938 3.938 1.131 1.131 3.938-3.938V18.5h1.6v-5.569l3.938 3.938 1.131-1.131-3.938-3.938H29.5v-1.6h-5.569l3.938-3.938-1.131-1.131L22.8 9.069z' fill='%23ffbe00' fill-rule='nonzero'/%3E%3Cpath d='M22 6c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z' fill='%23fff'/%3E%3Cpath d='M22 7c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z' fill='%23ffbe00' fill-rule='nonzero'/%3E%3Cpath d='M22 8c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3z' fill='gold'/%3E%3Cpath d='M20.026 11.034a4.508 4.508 0 013.855 3.435A4.001 4.001 0 0122 22H12a5 5 0 01-4.996-4.807C4.759 16.953 3 15.095 3 12.82c0-2.054 1.44-3.786 3.4-4.267C7.252 6.438 9.366 5 11.76 5c2.647 0 4.919 1.75 5.572 4.18 1.08.299 2.03.953 2.694 1.854z' fill='%23fff' fill-rule='nonzero'/%3E%3Cpath d='M11.76 6C9.562 6 7.693 7.45 7.155 9.436 5.391 9.604 4 11.046 4 12.82c0 1.887 1.576 3.4 3.5 3.4.199 0 .395-.016.586-.048A4 4 0 0012 21h10a3 3 0 00.984-5.835A3.509 3.509 0 0019.465 12a4.003 4.003 0 00-2.982-1.97C16.188 7.75 14.18 6 11.76 6z' fill='%239f9f9f'/%3E%3Cg fill-rule='nonzero'%3E%3Cpath d='M8.531 15.007a2.579 2.579 0 01-1.031.213c-1.38 0-2.5-1.075-2.5-2.4s1.12-2.4 2.5-2.4c.172 0 .34.017.503.049C8.08 8.54 9.733 7 11.76 7c1.873 0 3.426 1.314 3.713 3.034a4.004 4.004 0 00-3.347 2.968 3.998 3.998 0 00-3.594 2.005z' fill='%23d4d4d4'/%3E%3Cpath d='M22 15.5a2.5 2.5 0 00-3.143-2.417 3.001 3.001 0 00-5.852 1.09A3 3 0 1012 20h10a2 2 0 10-.05-4c.033-.162.05-.33.05-.501z' fill='%23fff'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

.half-cloudy-night {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='34' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h34v24H0z' fill='%23fff' fill-opacity='.01' opacity='.01'/%3E%3Cpath d='M17.021 6.391A5.943 5.943 0 0121.385 4.5c2.317 0 4.377 1.322 5.33 3.306 2.171.531 3.785 2.453 3.785 4.754 0 2.386-1.732 4.356-4.012 4.804A5.5 5.5 0 0121 22.5H11a4.5 4.5 0 01-3.461-7.376 5.004 5.004 0 01-.004-.03 7.472 7.472 0 01-4.972-5.003L1.66 7.072l2.912 1.204a3.615 3.615 0 004.342-5.415L7.106.283l3.142.22a7.47 7.47 0 016.773 5.888z' fill='%23fff' fill-rule='nonzero'/%3E%3Cpath d='M5.952 10.048A5.115 5.115 3 0010.142 2 5.967 5.967 0 114 9.662a5.1 5.1 0 001.952.386z' fill='%236ebace' fill-rule='nonzero'/%3E%3Cpath d='M9.718 12.92a4.967 4.967 0 002.176-9.435 6.115 6.115 0 01-6.062 7.562 4.968 4.968 0 003.886 1.872z' fill='%23b7e2ee'/%3E%3Cpath d='M8 14.5a4.5 4.5 0 015.77-4.318 4.983 4.983 0 012.365-1.107C16.685 6.727 18.842 5 21.385 5c2.208 0 4.158 1.308 4.978 3.24 2.07.394 3.637 2.175 3.637 4.32 0 2.274-1.758 4.13-4 4.373V17a5 5 0 01-5 5H11a4 4 0 01-2.933-6.72A4.522 4.522 0 018 14.5z' fill='%23fff' fill-rule='nonzero'/%3E%3Cpath d='M18.002 10.127a4.007 4.007 0 012.872 2.875L21 13c1.48 0 2.773.804 3.465 2H25.5a2.5 2.5 0 10-.732-4.891C24.69 8.379 23.206 7 21.385 7c-1.826 0-3.315 1.389-3.383 3.127z' fill='%23d4d4d4'/%3E%3Cpath d='M24.874 16A4 4 0 0121 21H11a3 3 0 01-1.819-5.386 3.5 3.5 0 014.83-4.272A3.997 3.997 0 0117 10c.141-2.239 2.058-4 4.385-4 1.963 0 3.641 1.255 4.194 3a3.5 3.5 0 01-.079 7z' fill='%23979797' fill-rule='nonzero'/%3E%3Cpath d='M9 18a2 2 0 002 2h10a3 3 0 10-1.005-5.828 3 3 0 00-5.719-1.432 2.5 2.5 0 00-3.736 3.312A2 2 0 009 18.001z' fill='%23fff'/%3E%3Cpath d='M18.002 10.127a4.007 4.007 0 012.872 2.875L21 13c1.48 0 2.773.804 3.465 2H25.5a2.5 2.5 0 10-.732-4.891C24.69 8.379 23.206 7 21.385 7c-1.826 0-3.315 1.389-3.383 3.127z' fill='%23d4d4d4'/%3E%3C/g%3E%3C/svg%3E");
}

.rainicons {
	top: 20px;
	position: relative;
	height: 14px;
	background-repeat: no-repeat;
}

.windborder{
	position: absolute;
	bottom:0;
	height: 3px;
}

.icon-rain1 {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg height='14' width='32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 1h32v13H0z' fill='%23fff' opacity='.01'/%3E%3Cpath d='M14.956 13.595c-2.478-.282-4.237-2.358-3.919-4.762.09-.68.346-1.398.742-2.157.415-.795.976-1.622 1.648-2.465a26.406 26.406 0 012.306-2.528l.878-.824.648 1.014a25.983 25.983 0 011.352 2.478c.407.855.742 1.691.983 2.488.343 1.137.483 2.157.365 3.047-.316 2.39-2.538 3.99-5.003 3.71z' fill='%23fff'/%3E%3Cpath d='M15.07 12.602c-1.917-.219-3.287-1.785-3.042-3.638.368-2.779 4.389-6.552 4.389-6.552s2.918 4.564 2.551 7.343c-.245 1.853-1.982 3.065-3.899 2.847zm.575-7.582c-.74.891-1.346 1.747-1.769 2.524-.346.636-.551 1.189-.611 1.622-.16 1.156.687 2.114 1.951 2.253 1.264.138 2.346-.61 2.505-1.766.082-.59-.04-1.438-.36-2.454-.257-.818-.628-1.706-1.085-2.627l-.105-.21s.051-.038-.526.658z' fill='%2312a6d0'/%3E%3C/g%3E%3C/svg%3E");
}

.icon-rain2 {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg height='14' width='32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 1h32v13H0z' fill='%23fff' opacity='.01'/%3E%3Cpath d='M10.956 13.595c-2.478-.282-4.237-2.358-3.919-4.762.09-.68.346-1.398.742-2.157.415-.795.976-1.622 1.648-2.465a26.406 26.406 0 012.306-2.528l.878-.824.648 1.014a25.983 25.983 0 011.352 2.478c.407.855.742 1.691.983 2.488.343 1.137.483 2.157.365 3.047-.316 2.39-2.538 3.99-5.003 3.71z' fill='%23fff'/%3E%3Cpath d='M11.07 12.602c-1.917-.219-3.287-1.785-3.042-3.638.368-2.779 4.389-6.552 4.389-6.552s2.918 4.564 2.551 7.343c-.245 1.853-1.982 3.065-3.899 2.847zm.575-7.582c-.74.891-1.346 1.747-1.769 2.524-.346.636-.551 1.189-.611 1.622-.16 1.156.687 2.114 1.951 2.253 1.264.138 2.346-.61 2.505-1.766.082-.59-.04-1.438-.36-2.454-.257-.818-.628-1.706-1.085-2.627l-.105-.21s.051-.038-.526.658z' fill='%2312a6d0'/%3E%3Cg%3E%3Cpath d='M19.956 13.595c-2.478-.282-4.237-2.358-3.919-4.762.09-.68.346-1.398.742-2.157.415-.795.976-1.622 1.648-2.465a26.406 26.406 0 012.306-2.528l.878-.824.648 1.014a25.983 25.983 0 011.352 2.478c.407.855.742 1.691.983 2.488.343 1.137.483 2.157.365 3.047-.316 2.39-2.538 3.99-5.003 3.71z' fill='%23fff'/%3E%3Cpath d='M20.07 12.602c-1.917-.219-3.287-1.785-3.042-3.638.368-2.779 4.389-6.552 4.389-6.552s2.918 4.564 2.551 7.343c-.245 1.853-1.982 3.065-3.899 2.847zm.575-7.582c-.74.891-1.346 1.747-1.769 2.524-.346.636-.551 1.189-.611 1.622-.16 1.156.687 2.114 1.951 2.253 1.264.138 2.346-.61 2.505-1.766.082-.59-.04-1.438-.36-2.454-.257-.818-.628-1.706-1.085-2.627l-.105-.21s.051-.038-.526.658z' fill='%2312a6d0'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

.icon-rain3 {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg height='14' width='32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 1h32v13H0z' fill='%23fff' opacity='.01'/%3E%3Cpath d='M5.956 13.595c-2.478-.282-4.237-2.358-3.919-4.762.09-.68.346-1.398.742-2.157.415-.795.976-1.622 1.648-2.465a26.406 26.406 0 012.306-2.528L7.61.859l.648 1.014a25.983 25.983 0 011.352 2.478c.407.855.742 1.691.983 2.488.343 1.137.483 2.157.365 3.047-.316 2.39-2.538 3.99-5.003 3.71z' fill='%23fff'/%3E%3Cpath d='M6.07 12.602c-1.917-.219-3.287-1.785-3.042-3.638.368-2.779 4.389-6.552 4.389-6.552s2.918 4.564 2.551 7.343c-.245 1.853-1.982 3.065-3.899 2.847zm.575-7.582c-.74.891-1.346 1.747-1.769 2.524-.346.636-.551 1.189-.611 1.622-.16 1.156.687 2.114 1.951 2.253 1.264.138 2.346-.61 2.505-1.766.082-.59-.04-1.438-.36-2.454-.257-.818-.628-1.706-1.085-2.627l-.105-.21s.051-.038-.526.658z' fill='%2312a6d0'/%3E%3Cpath d='M14.956 13.595c-2.478-.282-4.237-2.358-3.919-4.762.09-.68.346-1.398.742-2.157.415-.795.976-1.622 1.648-2.465a26.406 26.406 0 012.306-2.528l.878-.824.648 1.014a25.983 25.983 0 011.352 2.478c.407.855.742 1.691.983 2.488.343 1.137.483 2.157.365 3.047-.316 2.39-2.538 3.99-5.003 3.71z' fill='%23fff'/%3E%3Cpath d='M15.07 12.602c-1.917-.219-3.287-1.785-3.042-3.638.368-2.779 4.389-6.552 4.389-6.552s2.918 4.564 2.551 7.343c-.245 1.853-1.982 3.065-3.899 2.847zm.575-7.582c-.74.891-1.346 1.747-1.769 2.524-.346.636-.551 1.189-.611 1.622-.16 1.156.687 2.114 1.951 2.253 1.264.138 2.346-.61 2.505-1.766.082-.59-.04-1.438-.36-2.454-.257-.818-.628-1.706-1.085-2.627l-.105-.21s.051-.038-.526.658z' fill='%2312a6d0'/%3E%3Cg%3E%3Cpath d='M23.956 13.595c-2.478-.282-4.237-2.358-3.919-4.762.09-.68.346-1.398.742-2.157.415-.795.976-1.622 1.648-2.465a26.406 26.406 0 012.306-2.528l.878-.824.648 1.014a25.983 25.983 0 011.352 2.478c.407.855.742 1.691.983 2.488.343 1.137.483 2.157.365 3.047-.316 2.39-2.538 3.99-5.003 3.71z' fill='%23fff'/%3E%3Cpath d='M24.07 12.602c-1.917-.219-3.287-1.785-3.042-3.638.368-2.779 4.389-6.552 4.389-6.552s2.918 4.564 2.551 7.343c-.245 1.853-1.982 3.065-3.899 2.847zm.575-7.582c-.74.891-1.346 1.747-1.769 2.524-.346.636-.551 1.189-.611 1.622-.16 1.156.687 2.114 1.951 2.253 1.264.138 2.346-.61 2.505-1.766.082-.59-.04-1.438-.36-2.454-.257-.818-.628-1.706-1.085-2.627l-.105-.21s.051-.038-.526.658z' fill='%2312a6d0'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

.icon-n-bkn {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='34' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h34v24H0z' fill='%23fff' fill-opacity='.01' opacity='.01'/%3E%3Cpath d='M17.021 6.391A5.943 5.943 0 0121.385 4.5c2.317 0 4.377 1.322 5.33 3.306 2.171.531 3.785 2.453 3.785 4.754 0 2.386-1.732 4.356-4.012 4.804A5.5 5.5 0 0121 22.5H11a4.5 4.5 0 01-3.461-7.376 5.004 5.004 0 01-.004-.03 7.472 7.472 0 01-4.972-5.003L1.66 7.072l2.912 1.204a3.615 3.615 0 004.342-5.415L7.106.283l3.142.22a7.47 7.47 0 016.773 5.888z' fill='%23fff' fill-rule='nonzero'/%3E%3Cpath d='M5.952 10.048A5.115 5.115 3 0010.142 2 5.967 5.967 0 114 9.662a5.1 5.1 0 001.952.386z' fill='%236ebace' fill-rule='nonzero'/%3E%3Cpath d='M9.718 12.92a4.967 4.967 0 002.176-9.435 6.115 6.115 0 01-6.062 7.562 4.968 4.968 0 003.886 1.872z' fill='%23b7e2ee'/%3E%3Cpath d='M8 14.5a4.5 4.5 0 015.77-4.318 4.983 4.983 0 012.365-1.107C16.685 6.727 18.842 5 21.385 5c2.208 0 4.158 1.308 4.978 3.24 2.07.394 3.637 2.175 3.637 4.32 0 2.274-1.758 4.13-4 4.373V17a5 5 0 01-5 5H11a4 4 0 01-2.933-6.72A4.522 4.522 0 018 14.5z' fill='%23fff' fill-rule='nonzero'/%3E%3Cpath d='M18.002 10.127a4.007 4.007 0 012.872 2.875L21 13c1.48 0 2.773.804 3.465 2H25.5a2.5 2.5 0 10-.732-4.891C24.69 8.379 23.206 7 21.385 7c-1.826 0-3.315 1.389-3.383 3.127z' fill='%23d4d4d4'/%3E%3Cpath d='M24.874 16A4 4 0 0121 21H11a3 3 0 01-1.819-5.386 3.5 3.5 0 014.83-4.272A3.997 3.997 0 0117 10c.141-2.239 2.058-4 4.385-4 1.963 0 3.641 1.255 4.194 3a3.5 3.5 0 01-.079 7z' fill='%23979797' fill-rule='nonzero'/%3E%3Cpath d='M9 18a2 2 0 002 2h10a3 3 0 10-1.005-5.828 3 3 0 00-5.719-1.432 2.5 2.5 0 00-3.736 3.312A2 2 0 009 18.001z' fill='%23fff'/%3E%3Cpath d='M18.002 10.127a4.007 4.007 0 012.872 2.875L21 13c1.48 0 2.773.804 3.465 2H25.5a2.5 2.5 0 10-.732-4.891C24.69 8.379 23.206 7 21.385 7c-1.826 0-3.315 1.389-3.383 3.127z' fill='%23d4d4d4'/%3E%3C/g%3E%3C/svg%3E");
}

.rain_amount {
	position: absolute;
	bottom: -1px;
	left: 16px;
}

</style>
